import React, {useState, useContext} from "react";
import ListItem from "../common/ListItem";
import {UserContext} from "../common/UserContext";
import {TemplateContext} from "../common/TemplateContext";
import ListGroup from "../common/ListGroup";
import CircularLoader from "../common/CircularLoader";

const ClassNavigation = props => {
    const {indicatorPlacement, tabIndex = 0} = props;
    const {user, updateClass} = useContext(UserContext);
    const {singlePage} = useContext(TemplateContext);
    let otherListGroupOptions  = {}
    if (indicatorPlacement) otherListGroupOptions.indicatorPlacement = indicatorPlacement;

    if(user == undefined) {
        return <CircularLoader pageCentered={false}/>
    }

    if (user.classes === undefined) {
        return null;
    }

    return (
        <ListGroup title={'My classes'} tabIndex={tabIndex} itemCount={user.classes.length} disabled={user.classes.length == 0} startOpen={user.classes.length > 0} {...otherListGroupOptions}>
            {user.classes.map((clazz, index) => {
                const handleOnClick = () => {
                    updateClass(clazz.classId);
                }

                return <ListItem url="#"  key={index} tabIndex={index == 0 ? 0 : -1} active={clazz.classId == user.classId} onClick={handleOnClick}>
                    {clazz.className}
                </ListItem>
            })}
        </ListGroup>
    );
}

export default ClassNavigation;